<template lang="pug">
  span.custom
    transition(name="fade")
      span.fake-checkbox(ref="fakeCheck",@click.prevent="flip",:class="{'checked': value, 'unchecked': !value}")
        span.checkmark &#x2713;
    input(:value="value",:id="uniqueId",type="checkbox",@changed="flip")
    label(:for="uniqueId",@click.prevent="flip")
      | &nbsp;
      slot
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      dirty: false, // Dirty is used to prevent the "un-checking" animation from runnings on first render
    }
  },
  methods: {
    flip() {
      this.dirty = true
      this.$emit('input', !this.value)
    },
  },
  computed: {
    uniqueId: function() {
      return `checkbox-${this._uid}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom';
input {
  display: none;
}

.fake-checkbox {
  display: inline-block;
  position: relative;
  top: 3px;
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid rgba(black, 0.3);
  border-radius: 3px;
  color: rgba(black, 0);
  cursor: pointer;
}

.fake-checkbox.checked {
  border-color: $primary;
  background-color: $primary;
  color: white;
  transition: background-color 0.1s, border-color 0.1s;
}

.fake-checkbox.unchecked {
  transition: background-color 0.1s, border-color 0.1s;
}

.checkmark {
  position: relative;
  top: -2px;
  left: 3px;
}

label {
  display: inline;
}
</style>
